import { useDispatch } from "react-redux";

import { saveSearchModalToggledAction } from "app/pages/sales-intelligence/sub-modules/advanced-search/store/action-creators";

import useSavedSearchTrigger from "../../hooks/useSavedSearchTrigger";

import SaveSearchTriggerModalContainer from "./SaveSearchTriggerModalContainer";

const SaveSearchTriggerModalMount = () => {
    const dispatch = useDispatch();
    const { isGuardConditionSatisfied } = useSavedSearchTrigger();

    if (!isGuardConditionSatisfied) {
        return null;
    }

    return (
        <SaveSearchTriggerModalContainer
            onConfirm={() => dispatch(saveSearchModalToggledAction({ isOpen: true, saveMode: "onExport" }))}
        />
    );
};

export default SaveSearchTriggerModalMount;
